export const grommetKnueTheme = {
  global:
  { 
    font: { family: "Noto Sans"},
    colors: {
      "knue-background": "#FAFAFA",
      "knue-searchbox": "white",
      "knue-icon": "#474973"
    }
  }
}

export const getScreenDimension = () => {
  let width = window.innerWidth;
  let height = window.innerHeight;
  return [width, height];
};

export const NarrowWidth = 375;
export const TwoColumnWidth = 1000;